import Chip from "@mui/material/Chip";
import Button from "@mui/material/Button";
import TableRow from "@mui/material/TableRow";
import SyncIcon from "@mui/icons-material/Sync";
import EditIcon from "@mui/icons-material/Edit";
import TableCell from "@mui/material/TableCell";
import DeleteIcon from "@mui/icons-material/Delete";
import ButtonGroup from "@mui/material/ButtonGroup";
import LockResetIcon from "@mui/icons-material/LockReset";

import { UserRoles } from "./user-roles.enum";
import { PasswordStatus } from "./password-status.enum";
import { columns, userToWarehouseAccessType } from "./common";

export default function EmployeeTableRow({ row, buttonsActive, actions }) {
	const handleEditRowClick = () => {
		actions.editRow(row.id);
	};
	const handleDeleteRowClick = () => {
		actions.tryDeleteRow(row.id);
	};
	const handleSynchronizeOrdersWithManagerClick = () => {
		actions.synchronizeOrdersWithManager(row.id);
	};
	const handleResetPasswordClick = () => {
		actions.tryResetPassword(row);
	};
	return (
		<>
			<TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
				{columns.map((column) => (
					<TableCell key={column.id} align={column.align}>
						{column.id === "name" && row.name}
						{column.id === "friendlyName" && row.friendlyName}
						{column.id === "role" && row.role}
						{column.id === "minorRoles" &&
							row.minorRoles.map((r) => <Chip label={r} />)}
						{column.id === "managerId" && row.emloyee1c}
						{column.id === "email" && row.email}
						{column.id === "readWarehouses" &&
							row.userToWarehouses
								?.filter(
									(utw) => utw.accessType === userToWarehouseAccessType.READ
								)
								?.map((utw) => <Chip label={utw.warehouse.city} />)}
						{column.id === "writeWarehouses" &&
							row.userToWarehouses
								?.filter(
									(utw) => utw.accessType === userToWarehouseAccessType.WRITE
								)
								?.map((utw) => <Chip label={utw.warehouse.city} />)}
						{column.id === "tempPassword" &&
							(row.passwordStatus === PasswordStatus.TEMPORARY
								? row.tempPassword
								: "")}
						{column.id === "buttons" && (
							<div style={{ display: "flex", gap: 15 }}>
								<ButtonGroup
									disabled={!buttonsActive}
									variant="outlined"
									aria-label="outlined button group"
								>
									<Button onClick={() => handleEditRowClick()}>
										<EditIcon />
									</Button>
									<Button onClick={() => handleDeleteRowClick()} color="error">
										<DeleteIcon />
									</Button>
									<Button
										disabled={row.role !== UserRoles.MANAGER || !row.emloyee1c}
										onClick={() => handleSynchronizeOrdersWithManagerClick()}
									>
										<SyncIcon />
									</Button>
									<Button
										onClick={() => handleResetPasswordClick()}
										color="secondary"
									>
										<LockResetIcon />
									</Button>
								</ButtonGroup>
							</div>
						)}
					</TableCell>
				))}
			</TableRow>
		</>
	);
}
